import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import MappedMeds from "./mappedMeds";
import UnmappedMeds from "./unmappedMeds";
import { useState, useEffect } from "react";
import api from "../../lib/api";
import { useAuth } from "../../lib/authContext";
import FastMovingMeds from "./fastMovingMeds";

export default function MedsMappings() {
  const [entities, setEntities] = useState<any>([]);
  const { userEntities, userRole } = useAuth();

  useEffect(() => {
    const isSuperAdmin = userRole?.role_name === "Super Admin";
    if (userEntities && userEntities.length > 0) {
      const formatted = userEntities.map((e) => ({
        value: e.entity_id,
        label: isSuperAdmin && (e as any).is_active === false
          ? `${e.name} (${e.branch_id ?? ""}) [Inactive]`
          : `${e.name} (${e.branch_id ?? ""})`,
      }));
      setEntities([
        { value: 0, label: "All Pharmacies" },
        ...formatted,
      ]);
    } else {
      setEntities([
        { value: 0, label: "All Pharmacies" },
      ]);
    }
  }, [userEntities, userRole]);

  return (
    <div className="container mx-auto p-4 bg-white rounded-md shadow-md dark:bg-gray-800">
      <h1 className="text-2xl font-bold text-black dark:text-white">
        Meds Mappings
      </h1>
      <Tabs defaultValue="mapped">
        <TabsList className="flex justify-center w-full mt-4">
          <TabsTrigger value="mapped" className="w-1/2">
            Mapped
          </TabsTrigger>
          <TabsTrigger value="unmapped" className="w-1/2">
            Unmapped
          </TabsTrigger>
          <TabsTrigger value="fastMoving" className="w-1/2">
            Fast Moving
          </TabsTrigger>
        </TabsList>

        <TabsContent value="mapped">
          <MappedMeds entities={entities} />
        </TabsContent>
        <TabsContent value="unmapped">
          <UnmappedMeds entities={entities} />
        </TabsContent>
        <TabsContent value="fastMoving">
          <FastMovingMeds entities={entities} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
